import { render, staticRenderFns } from "./venueAppointmentDetail.vue?vue&type=template&id=87f754c0&scoped=true"
import script from "./venueAppointmentDetail.vue?vue&type=script&lang=js"
export * from "./venueAppointmentDetail.vue?vue&type=script&lang=js"
import style0 from "./venueAppointmentDetail.vue?vue&type=style&index=0&id=87f754c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f754c0",
  null
  
)

export default component.exports